
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface MetricCardProps {
  title: string;
  value: number;
  recentChange: number;
  icon: LucideIcon;
  isLoading?: boolean;
  onClick?: () => void;
}

export const MetricCard = ({ 
  title, 
  value, 
  recentChange, 
  icon: Icon, 
  isLoading = false,
  onClick
}: MetricCardProps) => {
  const formatChange = (change: number) => {
    if (change === 0) return "No change this month";
    return change > 0 ? `+${change} from last month` : `${change} from last month`;
  };

  return (
    <Card 
      className={`${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}`}
      onClick={onClick}
    >
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <Icon className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2">
            <div className="h-8 w-16 bg-gray-200 animate-pulse rounded"></div>
            <div className="h-4 w-24 bg-gray-200 animate-pulse rounded"></div>
          </div>
        ) : (
          <>
            <div className="text-2xl font-bold">{value}</div>
            <p className="text-xs text-muted-foreground">
              {formatChange(recentChange)}
            </p>
          </>
        )}
      </CardContent>
    </Card>
  );
};
